import _ from 'lodash';
import React from 'react';

import {
  FormattedCode,
  StatusCheckIcon
} from 'modules/layer00';
import {
  Box,
  styled,
  Typography
} from '@mui/material';

import { Table } from 'iron-forge-react-modules';
import { DateTime } from 'luxon';
import * as types from './types';



export interface IApiRequest {
  id: string;
  metaCreated: DateTime;
  url: string;
  statusCode: number;
  method: string;
  requestBody: object;
  responseBody: object;

  isOK: boolean;
}

const TableComponent = Table.genTableComponent<types.IColumnId>();

const ExpandedContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(8),
  margin: theme.spacing(3)
}));

const CodeSectionTypography = styled(Typography)(({theme}) => ({
  fontSize: 14,
  fontWeight: 'bold',
  marginTop: theme.spacing(2)
}));



export interface IProps {
  apiRequests: IApiRequest[];
}

export const FC: React.FC<IProps> = props => {
  return (
    <TableComponent
      columns={[
        {
          id: 'sentAt',
          label: "Sent At"
        },

        {
          id: 'method',
          label: "Method"
        },
        {
          id: 'statusCode',
          label: "Status Code"
        },
        {
          id: 'url',
          label: "URL"
        },
        {
          id: 'elRightColumn',
          label: "OK?"
        }
      ]}

      rows={_.map(props.apiRequests, (req): types.IRow => ({
        id: req.id,
        expandedContent: (
          <ExpandedContentBox>
            <Box>
              <CodeSectionTypography>
                Request
              </CodeSectionTypography>

              <FormattedCode.FC content={JSON.stringify(req.requestBody, undefined, 2)} />
            </Box>

            <Box>
              <CodeSectionTypography>
                Response
              </CodeSectionTypography>

              <FormattedCode.FC content={JSON.stringify(req.responseBody, undefined, 2)} />
            </Box>
          </ExpandedContentBox>
        ),
        columnId2Value: {
          method: {
            type: 'string',
            label: _.toUpper(req.method)
          },

          sentAt: {
            type: 'string',
            label: req.metaCreated.toFormat('yyyy-MM-dd @ hh:mm a')
          },

          statusCode: {
            type: 'string',
            label: req.statusCode.toString()
          },

          url: {
            type: 'string',
            label: req.url
          },

          elRightColumn: {
            type: 'component',
            sortableValue: 0,
            label: <StatusCheckIcon.FC success={req.isOK} />
          }
        }
      }))}
      disableSorting />
  );
};
